import { AUTHORIZATION_KEY, REFRESH_TOKEN_KEY } from "../constants/storageConstants";
import { setCookie, getCookie, removeCookie } from "./storageProxy";
import { UserProfile } from "../types/user";

export const unsetAuthorizationToken = () => {
  removeCookie(AUTHORIZATION_KEY);
  removeCookie(REFRESH_TOKEN_KEY);
};

export const setAuthorizationToken = (token?: string) => {
  if (token) {
    setCookie(AUTHORIZATION_KEY, token);
  }
};

export const getAuthorizationToken = () => {
  return getCookie(AUTHORIZATION_KEY);
};

export const getFormattedAuthorizationToken = () => {
  const token = getAuthorizationToken();
  // Use Bearer token format for Keycloak (standard OAuth2/OIDC format)
  return token ? `Bearer ${token}` : "";
};

export const setRefreshToken = (token?: string) => {
  if (token) {
    setCookie(REFRESH_TOKEN_KEY, token);
  }
};

export const getRefreshToken = () => {
  return getCookie(REFRESH_TOKEN_KEY);
};

export const unsetRefreshToken = () => {
  removeCookie(REFRESH_TOKEN_KEY);
};

const USER_PROFILE_KEY = "user_profile";

export function setUserProfile(profile: UserProfile): void {
  setCookie(USER_PROFILE_KEY, JSON.stringify(profile));
}

export function getUserProfile(): UserProfile | null {
  const stored = getCookie(USER_PROFILE_KEY);
  if (!stored) return null;

  try {
    return JSON.parse(stored);
  } catch (error) {
    console.error("[auth] Failed to parse user profile:", error);
    return null;
  }
}

export function unsetUserProfile(): void {
  removeCookie(USER_PROFILE_KEY);
}
